// extracted by mini-css-extract-plugin
export default {"mainCon":"Box_mainCon__mLu4z"};